import { createFileRoute } from "@tanstack/react-router";
import { KnowledgeCompilationArtifactPage } from "@client/components/kb/compilation/artifact-page";

export const Route = createFileRoute("/_app/kb/$kbId/compilation/artifacts/$artifactId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { kbId, artifactId } = Route.useParams();
  return <KnowledgeCompilationArtifactPage kbId={kbId} artifactId={artifactId} />;
}
